module.exports = function() {
  return new Worker(__webpack_public_path__ + "68c00685c7e456d37e36.worker.js");
};